import { createFileRoute } from '@tanstack/react-router';

// Optional campaignId — set when reached from a campaign's Audience tab, so the page can navigate back to that
// campaign instead of the webinar's campaign overview once the import finishes.
export const Route = createFileRoute('/$webinarId/marketing/import')({
    validateSearch: (search: Record<string, unknown>): { campaignId?: string } => ({
        campaignId: typeof search.campaignId === 'string' ? search.campaignId : undefined
    })
});
